module.exports = __webpack_public_path__ + "media/common/text-da-pt-eabed6d5.svg";